import {checkAbleToPrint} from "../../services/api/apiNextBarcode"
import { logoutUser } from "../../services/AuthServices"
import showRequestPhotoModal from "./showRequestPhotoModal"

export default async (barcode, step = '', reset = '') => {
    if (!barcode) return false

    const vBarcode = barcode.replace(/#/gi, '')

    try {
        const data = await checkAbleToPrint(vBarcode, step)
        const {success, message, code} = Object.assign({}, data)

        if (success) return true
        if (!message) return true

        // Don request chup anh: hien modal rieng, to & ro de phan biet voi cac loi khac (vd hold ship)
        if (code === 'request_photo') {
            showRequestPhotoModal(message)
            typeof reset === 'function' && reset()
            return false
        }

        if(message.includes('hold ship') || message.includes('hold-ship') || message.includes('Không tìm thấy item') || message.includes('Barcode not found')) {
            window.alert(`Lỗi: ${message}`)
            typeof reset === 'function' && reset()
            return false
        }

        window.alert(message)

        const r = window.confirm('Bạn muốn tiếp tục?')
        if (r) return true

        typeof reset === 'function' && reset()

        return false
    } catch (e) {
        
        if (e.response && e.response.status === 401) {
            // console.log("Token hết hạn! Chuyển hướng đến đăng nhập...");
            logoutUser()
        }

        window.alert(`Lỗi: ${e.message}`)

        return false
    }
}

